<template>
    <v-container fluid>
    
    <v-row>
        <v-col cols="12" v-if="car">
            <v-row>
                <v-col cols="12" class=" pb-5">
                    <car-details-component :data="formatDetails(car)"></car-details-component>
                </v-col>
                <v-col cols="12" class="bg-black pb-5">
                    <hero-detail-component :data="formatHeroDetail(car,'acceleration')"></hero-detail-component>
                </v-col>
                <v-col cols="12" class="bg-black pb-5">
                    <hero-detail-component :data="formatHeroDetail(car,'enginepower')"></hero-detail-component>
                </v-col>
            </v-row>
        </v-col>
        <!-- Non mostrare la lista dei veicoli dati non sempre corretti -->
        <v-col  cols="12" class="d-none">
            <v-container>
                <v-row>
                <v-col cols="10">
                    <h3 class="text-h4 text-md-h3" data-aos="fade-right">
                        {{ t('commons.direct-from-fleet') }}
                    </h3>
                </v-col>
                <v-col cols="10" v-if="car">
                    <h3 data-aos="fade-right">
                      {{ car.brand +' - '+ car.displayName }}
                    </h3>
                </v-col>
                <v-col 
                    cols="12"
                    md="4"
                    lg="3"
                    class="mx-auto text-center"
                    data-aos="fade-up"
                    v-for="(auto, index) in list"
                    :key="index"
                >
                <v-card :key="auto.id">
                    <v-img
                        v-if="auto.images.list.length"
                        class="mt-0"
                        :src="auto.images.prefix+''+auto.images.list[0].idimg+'.jpg'"
                        :lazy-src="'https://fakeimg.pl/800x600?font=bebas&font_size=41&text='+auto.brand_label + ' \n' + auto.displayname"
                        lazy
                        cover
                        gradient="to bottom, rgba(0,0,0,1), rgba(0,0,0,0),rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0),  rgba(0,0,0,1)"
                        :alt="auto.brand_label + ' - ' + auto.displayname + ' - '+ 1+ ' pos 1'"
                    >
                    </v-img>
                    <v-img
                        v-else
                        class="mt-0"
                        :src="'https://fakeimg.pl/800x480?font=bebas&font_size=41&text='+auto.displayName"
                        lazy
                        cover
                        gradient="to bottom, rgba(0,0,0,1), rgba(0,0,0,0),rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0),  rgba(0,0,0,1)"
                        :alt="auto.brand_label + ' - ' + auto.displayname + ' - '+ 1+ ' pos 1'"
                    >
                    <v-chip size="small" class="float-end">car id: {{ auto.id }}</v-chip>
                    </v-img>
                    <v-card-title>
                        <!-- <h3 v-html="auto.model"></h3> -->
                        <span v-html="auto.brand+' '+auto.displayName"></span>
                    </v-card-title>
                   </v-card>
                </v-col>
            </v-row>
            </v-container>
        </v-col>
        <v-col class="d-none">
            <pre>{{ list }}</pre>
        </v-col>
    </v-row>
    </v-container>
</template>

<script setup>
    import CarDetailsComponent from '@/components/PageComponents/partials/CarDetailsComponent.vue'
    import HeroDetailComponent from '@/components/PageComponents/partials/HeroDetailComponent.vue'
    import { useLocale } from 'vuetify'
    const { t } = useLocale()
</script>


<script>
import {mapGetters} from "vuex";
export default{
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            list: 'carsDrive/list',
            page: 'pages/single',
            adminPage: 'AdminPages/single',
        }),
    },
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
        car: null,
        current_page: null
    }),
    watch:{
        list: {
            handler(list){
                if(list.length >= 1){
                    this.car = list[0];
                }
            },
            deep: true
        }
    },
    mounted(){
        this.car = null;
        this.current_page = (this.page) ? this.page : this.adminPage;
       
        this.getList()
        
        if(this.list.length >= 1){
            this.getList()
        }
    },
    methods:{
        async getList(){
            let data = {
                page: 1,
                pageSize: 10,
                brandId: this.current_page.brand.drive_id,
                modelId: this.current_page.drive_model_id,
                typeId: this.current_page.type.drive_id,
                online: false,
                availableOnly: false,
            }
            await this.$store.dispatch('carsDrive/getList',data)
        },

        translate(string){
            return this.$vuetify.locale.t(string)
        },

        formatHeroDetail(single, field){
            return {
                "label": this.translate("car.details."+field),
                "value": single[field],
                "unit_measure": null
            }
        },
        
        formatDetails(single){
            var data =  {
                "title": this.translate("car.details.title"),
                "details": []
            }

            var detailslist = ['maxspeed','fuel_label','transmission_label','enginedisplacement','maxMileRange','seats_label','trunkvolume_label'];

            detailslist.forEach(element => {
                if(single[element] ){
                    if( single[element] != 'n.a.' && single[element] != ''){
                        var detail = {
                            "label": this.translate("car.details."+element),
                            "value": single[element],
                            "unit_measure": null
                        }
                        data.details.push(detail)
                    }else{
                    }
                }else{
                }
            })
            
            return data;
                
            
        },
    }
}
</script>